import { makeStyles } from '@material-ui/core';
import { createFactoryStyles } from '../../../ui/styles/helpers';
export const useStyles = makeStyles(({ factory: factoryTheme }) => {
    return createFactoryStyles({
        layoutMain: {
            paddingTop: factoryTheme.spacing(4),
        },
        box: {
            marginBottom: factoryTheme.spacing(6),
        },
        discordIdField: {
            display: 'flex',
            alignItems: 'center',
            marginBottom: factoryTheme.spacing(2),
        },
        inputUser: {
            width: 100,
            marginRight: factoryTheme.spacing(1),
        },
        error: {
            color: factoryTheme.palette.red[100],
            marginTop: factoryTheme.spacing(2),
            marginBottom: factoryTheme.spacing(2),
            '&:empty': {
                display: 'none',
            },
        },
        tokenInput: {
            flexGrow: 1,
            marginLeft: factoryTheme.spacing(1),
            marginRight: factoryTheme.spacing(3),
        },
    });
});
